export default {
  login: {
    form: {
      username: {
        label: 'Usuário',
        placeholder: 'usuário',
      },
      password: {
        label: 'Senha',
        placeholder: 'senha',
      },
      submit: 'Entrar',
    },
    errors: {
      invalidCredentials: 'E-mail e/ou senha estão incorretos.',
    },
    forgotPassword: 'Esqueceu sua senha?',
  },
  forgetPassword: {
    title: 'Por favor, digite seu e-mail abaixo.',
    form: {
      email: {
        placeholder: 'E-mail',
      },
      submit: 'Enviar solicitação de mudança de senha',
    },
    errors: {
      invalidEmail: 'E-mail inválido.',
    },
    successMessage:
      'Nós te enviamos um e-mail com um link de redefinição de senha!',
  },
  recoverPassword: {
    title: 'Entre com sua nova senha.',
    form: {
      email: {
        label: 'E-mail',
        placeholder: 'E-mail',
      },
      newPassword: {
        label: 'Nova senha',
      },
      confirmPassword: {
        label: 'Confirme sua nova senha',
        invalid: 'As senhas não combinam.',
      },
      submit: 'Enviar',
    },
    errors: {
      typeNewPassword: 'Digite sua nova senha',
      passwordsDoNotMatch: 'As senhas não combinam.',
    },
    successMessage: 'Senha alterada com sucesso!',
    login: 'Voltar ao login',
  },
  form: {
    password: {
      placeholder: '********',
    },
  },
  navbar: {
    menu: {
      profile: 'Perfil',
      settings: 'Configuração',
      logout: 'Sair',
    },
  },
  newPassword: {
    title: 'Entre com sua nova senha.',
    oldPass: 'Senha atual',
    newPass: 'Nova senha',
    confirmNewPass: 'Confirme a nova senha',
    placeholders: {
      pass: 'Senha',
    },
    send_button: 'Enviar',
    error_confirm: 'As senhas não combinam.',
  },
  sidebar: {
    logoAlt: 'Sistema de gerenciamento',
    menu: {
      dashboard: 'Painel de controle',

      tools: {
        generate: 'Gerador de texto',
        breakText: 'Quebrar texto em linhas',
        wordSeparator: 'Separador de palavras',
        specialCharacterRemover: 'Removedor de caracteres especiais',
        wordGroups: 'Agrupador de palavras',
      },

      words: {
        title: 'Banco de palavras',
        list: 'Lista de palavras',
        import: 'Importar palavras',
        add: 'Adicionar palavras',
      },

      games: {
        title: 'Jogos',

        cryptograms: {
          title: 'Criptogramas',
          list: 'Lista',
          add: 'Adicionar',
        },

        crosswords: {
          title: 'Cruzadas',
          list: 'Lista',
          add: 'Adicionar',
          templates: 'Lista de templates',
        },

        huntingWords: {
          title: 'Caça-palavras',
          list: 'Lista',
          add: 'Adicionar',
        },

        shapeLinks: {
          title: 'Shape Links',
          list: 'Lista',
          add: 'Adicionar',
        },

        loop: {
          title: 'Loop',
          list: 'Lista',
          add: 'Adicionar',
        },

        numberSquare: {
          title: 'Number Square',
          list: 'Lista',
          add: 'Adicionar',
        },

        fences: {
          title: 'Fences',
          list: 'Lista',
          add: 'Adicionar',
        },

        walls: {
          title: 'Walls',
          list: 'Lista',
          add: 'Adicionar',
        },

        term: {
          title: 'Termo',
          list: 'Lista',
        },
      },

      users: {
        title: 'Usuários',
        list: 'Lista',
        add: 'Adicionar',
      },
    },
  },
  shared: {
    actions: {
      edit: 'Editar',
      delete: 'Excluir',
      view: 'Visualizar',
      back: 'Voltar',
      save: 'Salvar',
      cancel: 'Cancelar',
      confirm: 'Confirmar',
      generate: 'Gerar',
      clear: 'Limpar',
      copy: 'Copiar',
      copyText: 'Copiar texto',
      import: 'Importar',
      export: 'Exportar',
      search: 'Buscar',
      send: 'Enviar',
    },
    fonts: {
      placeholder: 'Selecionar fonte...',
      numbers: 'Números {n}',
      symbols: 'Símbolos {n}',
      fontCrypto: 'Font Crypto {n}',
    },
    pagination: {
      summary: 'Mostrando {from} a {to} de {total} registros',
      noResults: 'Nenhum resultado encontrado',
      prev: 'Anterior',
      next: 'Próximo',
    },
    puzzle: {
      columns: {
        name: 'Nome',
        template: 'Template',
        status: 'Status',
        level: 'Nível',
        options: 'Opções',
      },
      status: {
        draft: 'Rascunho',
        completed: 'Finalizado',
      },
      noContent: 'Ainda não tem nenhum jogo cadastrado.',
      selectGames: 'Selecionar jogos',
      complete: 'Concluir ({count})',
      export: 'Exportar ({count})',
      noSelected: 'Nenhum jogo selecionado',
      sendToSite: 'Enviar ao site ({count})',
      sendTitle: 'Enviar ao site',
      sendConfirm:
        'Enviar {count} jogo ao site principal? | Enviar {count} jogos ao site principal?',
      noDraftSelected: 'Nenhum dos jogos selecionados está em rascunho.',
      game: 'jogo',
      template: 'template',
      deleteTitle: 'Confirme exclusão do {label}',
      deleteMessage: 'Tem certeza que deseja excluir o {label} "{name}"?',
    },
    confirmation: {
      title: 'Confirmar exclusão',
      message: 'Tem certeza que deseja excluir',
    },
    gameStatus: {
      summary: '{placed} de {total} palavras {description}',
    },
    level: {
      easy: 'Fácil',
      medium: 'Médio',
      hard: 'Difícil',
    },
    export: {
      title: 'Exportar arquivos',
      fileFormat: 'Formato do arquivo:',
      style: 'Estilo:',
      unexpectedError: 'Ocorreu um erro inesperado na exportação.',
      noFiles: 'Nenhum arquivo para exportar.',
      converting: 'Convertendo {current} de {total} arquivos...',
      conversionError:
        'Ocorreu um erro durante a conversão de SVG para EPS. Por favor, tente novamente.',
      finishing: 'Finalizando exportação...',
      types: {
        enigma: 'Enigma',
        solution: 'Solução',
        combined: 'Enigma + Solução',
        wordList: 'Lista de palavras',
      },
      toggles: {
        colored: 'Colorido',
        transparentBg: 'Fundo Transparente',
        exportBank: 'Incluir Banco de Palavras',
      },
      radio: {
        arrowStyle: {
          label: 'Tipo de Seta:',
          triangle: 'Triângulo',
          filledCircle: 'Círculo Preenchido',
          emptyCircle: 'Círculo Vazado',
          dottedCircle: 'Círculo com Ponto',
        },
        pathWeight: {
          label: 'Espessura da linha:',
          thin: 'Fina',
          normal: 'Normal',
          bold: 'Espessa',
        },
      },
    },
    distribution: {
      checkboxLabel: 'Distribuir palavras por porcentagem',
      tooltip:
        'As palavras são distribuídas conforme as porcentagens. Se não houver espaço, serão usadas outras direções.',
      placeholder: 'Número em %',
      total: 'Total:',
      mustSum100: '(a soma deve ser 100%)',
    },
    upload: {
      dropOrChoose: 'Solte (ou escolha) um arquivo',
      clickOrDrag: 'Clique ou arraste o arquivo aqui',
      selectImage: 'Selecione uma imagem',
    },
    select: {
      placeholder: 'Selecione...',
    },
    scrollToTop: {
      tooltip: 'Voltar ao topo',
    },
    alert: {
      seconds: 'seg.',
    },
    deletedSuccess: 'Jogo excluído com sucesso',
    dashboard: {
      noResults: 'Não houve nenhum resultado.',
      viewAll: 'Ver todos →',
      statusRegisters: {
        title: 'Lista de registros por status',
      },
      lastRegisters: {
        title: 'Últimos registros',
        filters: {
          lastWeek: 'Última semana',
          today: 'Hoje',
          lastMonth: 'Último mês',
          lastYear: 'Último ano',
        },
      },
      status: {
        open: 'Rascunho',
        pending: 'Pendente',
        approved: 'Aprovado',
        canceled: 'Cancelado',
        closed: 'Concluído',
      },
    },
    editor: {
      placeholder: 'Text formatado',
    },
    input: {
      total: 'Total',
    },
    stats: {
      label: 'Label',
    },
    loader: {
      generating: 'Gerando...',
      generationCanceled: 'Geração cancelada.',
    },
  },
};
